import { render, staticRenderFns } from "./sourselist.vue?vue&type=template&id=5905f466&scoped=true&"
import script from "./sourselist.vue?vue&type=script&lang=js&"
export * from "./sourselist.vue?vue&type=script&lang=js&"
import style0 from "./sourselist.vue?vue&type=style&index=0&id=5905f466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5905f466",
  null
  
)

export default component.exports